// extracted by mini-css-extract-plugin
export default {"card":"BoardItem_card__94nbe","link":"BoardItem_link__5ZVTQ","buttons":"BoardItem_buttons__su1m5"};